
export default {
  //格式化数字
  toThousands(num) {
    return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
  },
  getTime() {
    let dt = new Date();
    let hh = dt.getHours();
    if (hh < 10)
      hh = '0' + hh;
    let mm = dt.getMinutes();
    if (mm < 10)
      mm = '0' + mm;
    let ss = dt.getSeconds();
    if (ss < 10)
      ss = '0' + ss;
    return hh + ":" + mm + ":" + ss;
  },
  getDate() {
    let dt = new Date();
    let yy = dt.getFullYear();
    let mm = dt.getMonth() + 1;
    if (mm < 10)
      mm = '0' + mm;
    let dd = dt.getDate();
    if (dd < 10)
      dd = '0' + dd;
    return yy + "/" + mm + "/" + dd;
  },
  getWeek() {
    let dt = new Date();
    let day = dt.getDay();
    var weeks = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
    return weeks[day];
  },
  
}



// WEBPACK FOOTER //
// ./src/statistics/assets/js/common.js